import dayjs from 'dayjs';
import { cn, FormatUtils } from '@shared/utils';
import type { GetAllCardsResponse } from '@shared/api';
import ArrowIcon from '@assets/images/arrow_mobile.svg';
import ManageIcon from '@assets/images/cards/manage_ico.svg';
import InvoiceIcon from '@assets/images/cards/invoices_ico.svg';
import StatementsIcon from '@assets/images/cards/statements_ico.svg';

interface MobileCardInfoProps {
  className?: string;
  card: GetAllCardsResponse;
  index: number;
  onChangeTab: (tab: string) => void;
  onManageCard: (card: GetAllCardsResponse, index: number) => void;
}

export const MobileCardInfo = (props: MobileCardInfoProps) => {
  if (!props.card) return null;
  return (
    <div className={cn('max-md:rounded-t-xl max-md:bg-[#fafafa] max-md:p-4 max-md:pb-17.5', props.className)}>
      <div>
        {props.card.paymentDue && (
          <div className='max-md:-mt-4.5 max-md:mb-1.5 max-md:flex max-md:items-center max-md:justify-center max-md:border-b max-md:border-b-[#4c4c4c10] max-md:py-4 max-md:text-[#0f0f11]'>
            <span
              className='max-md:mx-auto max-md:rounded-lg max-md:bg-[#e54338] max-md:px-2 max-md:py-1.5 max-md:text-white'
              onClick={() => props.onChangeTab('invoices')}
            >
              Payment due on {dayjs(props.card.paymentDue || new Date()).format('DD MMM YYYY')}
            </span>
          </div>
        )}
        <div className='max-md:flex max-md:items-center max-md:justify-between max-md:border-b max-md:border-b-[#4c4c4c10] max-md:py-4 max-md:text-[#0f0f11]'>
          <span>Statement Balance:</span>
          <span className={cn(props.card.statementBalance <= 0 && 'text-[#d0021b]')}>
            {props.card.currency} <b>{FormatUtils.insertSpaces(props.card.statementBalance) || '57,383'}</b>
          </span>
        </div>

        <div className='max-md:flex max-md:items-center max-md:justify-between max-md:border-b max-md:border-b-[#4c4c4c10] max-md:py-4 max-md:text-[#0f0f11]'>
          <span>New Charges:</span>{' '}
          <span>
            {props.card.currency} <b>{FormatUtils.insertSpaces(props.card.newCharges) || '1,028,438'}</b>
          </span>
        </div>

        <div className='max-md:flex max-md:items-center max-md:justify-between max-md:border-b max-md:border-b-[#4c4c4c10] max-md:py-4 max-md:text-[#0f0f11]'>
          <span>New Credits:</span>{' '}
          <span>
            {props.card.currency} <b>{FormatUtils.insertSpaces(props.card.newCredits) || '1,030,511'}</b>
          </span>
        </div>
        <div className='max-md:flex max-md:items-center max-md:justify-between max-md:border-b max-md:border-b-[#4c4c4c10] max-md:py-4 max-md:text-[#0f0f11]'>
          <span>Previous Balance:</span>{' '}
          <span className={cn(props.card.previousBalance <= 0 && 'text-[#d0021b]')}>
            {props.card.currency} <b>{FormatUtils.insertSpaces(props.card.previousBalance) || '59,463'}</b>
          </span>
        </div>
      </div>
      <ul className='py-8'>
        <li
          className='relative mb-3 flex h-[60px] w-full items-center justify-between bg-white px-4 font-[Prata] text-lg text-[#0f0f11]'
          onClick={() => props.onManageCard(props.card, props.index)}
        >
          <div className='flex items-center gap-2'>
            <ManageIcon />
            Manage the Card
          </div>
          <ArrowIcon />
        </li>
        <li
          className='relative mb-3 flex h-[60px] w-full items-center justify-between bg-white px-4 font-[Prata] text-lg text-[#0f0f11]'
          onClick={() => props.onChangeTab('invoices')}
        >
          <div className='flex items-center gap-2'>
            <InvoiceIcon />
            Invoices
          </div>
          <ArrowIcon />
        </li>
        <li
          className='relative mb-3 flex h-[60px] w-full items-center justify-between bg-white px-4 font-[Prata] text-lg text-[#0f0f11]'
          onClick={() => props.onChangeTab('statements')}
        >
          <div className='flex items-center gap-2'>
            <StatementsIcon />
            Statements
          </div>
          <ArrowIcon />
        </li>
      </ul>
    </div>
  );
};
